<template>
  <div class="market-revelRecord-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" :unfold="true">
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <div class="fun-btn-box">
    </div>
     <Table
      :loading="loading"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn" type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #oldLevel="{ row }">{{ row.oldLevel }}</template>
      <template #newLevel="{ row }">{{ row.newLevel }}</template>
      <template #operateTime="{ row }">{{ row.operateTime ? $moment(row.operateTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #remark="{ row }">
        <el-button v-if="row.remark" type="text" @click="onLookRemark(row)">查看备注</el-button>
        <span v-else>---</span>
      </template>
      <template #operator="{ row }">{{ row.operator }}</template>
    </Table>
    <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
      <div class="remark-box" v-html="currentRow.remark"></div>
    </el-dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import aes from '@/common/aes.js'
import { downFile } from "@/utils";
import {api_getMemberRecordList,api_postMemberRecordExport} from '@/api/member'
import { api_getListLevelNoPage, api_getUserPhone } from '@/api/common'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "mLevelRecord",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
         {
          label: "会员等级",
          placeholder: "请选择会员等级",
          type: "select",
          multiple: false,
          key: "levelId",
          option: [],
        },
        {
          label: "手机号",
          placeholder: "请输入手机号",
          type: "input",
          key: "phone",
          isNumber: true,
          maxLength: 11
        },
        {
          label: "更新时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "operateTime",
        },
      ],
      form: {},
      currentRow:{},
      tableKey: false,
      exportLoading: false,
      isShowRemarkDialog:false,
      tableThData: [
        { prop: "phone", label: "会员手机号", minWidth: "180", },
        { prop: "oldLevel", label: "原等级", minWidth: "180", },
        { prop: "newLevel", label: "等级变动", minWidth: "180", },
        { prop: "operateTime", label: "更新时间", minWidth: "160", },
        { prop: "remark", label: "备注", minWidth: "180", },
        { prop: "operator", label: "操作人", minWidth: "180", },
      ],

    };
  },
  created () {
    this.getListLevel()
  },
  methods: {
  
     // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      params.beginTime = this.form.operateTime ? this.form.operateTime[0] : ''
      params.endTime = this.form.operateTime ? this.form.operateTime[1] : ''
      delete params.operateTime
      this.$router.push({query: params})
      const data = await api_getMemberRecordList(params)
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 获取会员等级
    async getListLevel () {
      const data = await api_getListLevelNoPage()
      const list = data.map((item) => {
        let obj = {
          label: item.name,
          value: item.id
        }
        return obj
      })
      this.renderData[0].option = list
    },
   // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },
    // 查看备注
    onLookRemark(row) {
      this.currentRow = row
      this.isShowRemarkDialog = true
    },
     async onExport() {
      this.exportLoading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      params.beginTime = this.form.operateTime ? this.form.operateTime[0] : ''
      params.endTime = this.form.operateTime ? this.form.operateTime[1] : ''
      delete params.operateTime
      try {
        let res = await api_postMemberRecordExport(params)
        downFile(res)
        this.exportLoading = false
      } catch (error) {
        this.exportLoading = false
      }
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-revelRecord-index {
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;
  .fun-btn-box {
    margin-top: 20px;
  }

  .look-phone-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }
  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }
  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
